import React from "react"

export default function Image({
    src,
    alt = "",
    width,
    height,
    className = "",
    ...props
}) {
    const style = {}
    
    if (width) {
        style.width = typeof width === 'number' ? `${width}px` : width
    }
    
    if (height) {
        style.height = typeof height === 'number' ? `${height}px` : height
    }

    return (
        <img
            src={src}
            alt={alt}
            style={style}
            className={className}
            {...props}
        />
    )
}

